import { Pipe, PipeTransform } from '@angular/core';
import { SearchTypeEnum } from 'src/app/utils/enums/search-type-enum';
import { LocalAuth } from 'src/app/utils/interfaces/new/localauth.interface';
import { Account } from 'src/app/utils/interfaces/old/account-interface';

@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {

  transform(items: any[], searchText: string, type: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLocaleLowerCase();
    switch (type) {
      case SearchTypeEnum.user:
        return items.filter(it => {
          if (it.nom.toLocaleLowerCase().includes(searchText)) {
            return true;
          } else {
            return false;
          }
        });
        break;
      case SearchTypeEnum.account:
        return items.filter((it: LocalAuth) => {
          if (it.utilisateur.email.toLocaleLowerCase().includes(searchText) ||
            it.utilisateur.pseudo.toLocaleLowerCase().includes(searchText) ||
            (it.profil && it.profil.cabinet && it.profil.cabinet.nom.toLocaleLowerCase().includes(searchText))) {
            return true;
          } else {
            return false;
          }
        });
        break;
      case SearchTypeEnum.profil:
        return items.filter(it => {
          if (it.name.toLocaleLowerCase().includes(searchText)) {
            return true;
          } else {
            return false;
          }
        });
        break;
      case SearchTypeEnum.office:
        return items.filter(it => {
          if (it.nom.toLocaleLowerCase().includes(searchText) ||
            it.adresse.toLocaleLowerCase().includes(searchText)) {
            return true;
          } else {
            return false;
          }
        });
        break;
      case SearchTypeEnum.docteur:
        return items.filter(it => {
          if (it.nom.toLocaleLowerCase().includes(searchText) ||
            it.prenom.toLocaleLowerCase().includes(searchText)) {
            return true;
          } else {
            return false;
          }
        });
        break;
      case SearchTypeEnum.profilOffice:
        return items.filter(it => {
          if (it.cabinet.nom.toLocaleLowerCase().includes(searchText) ||
            it.cabinet.adresse.toLocaleLowerCase().includes(searchText)) {
            return true;
          } else {
            return false;
          }
        });
        break;
      case SearchTypeEnum.role:
        return items.filter(it => {
          if (it.nom.toLocaleLowerCase().includes(searchText)) {
            return true;
          } else {
            return false;
          }
        });
        break;
      default:
        return items;
        break;
    }
  }

}
